import React from 'react';
import { timeMapping } from '../../../../../components/TimeSelect/timeMapping';
import { Button, Heading } from '../../../../../flayr-components';

interface IRescheduleSectionProps {
  title?: string;
  eventDate?: string;
  startTime?: string;
  finishTime?: string;
  offered?: boolean;
  onAcceptOffer?: (e?: any) => void;
  onOther?: (e?: any) => void;
}

const RescheduleSection: React.FC<React.PropsWithChildren<IRescheduleSectionProps>> = ({
  eventDate,
  startTime,
  finishTime,
  title = 'Reschedule Requested',
  offered,
  onAcceptOffer,
  onOther,
}) => {
  return (
    <div>
      <Heading bold="medium" className="mb-2 lg:text-4xl lg:mb-12" size="lg">
        {title}
      </Heading>

      <ul className="grid gap-1 text-sm lg:pb-4 lg:text-lg">
        <li hidden={!eventDate}>Date: {eventDate}</li>
        {/* start time */}
        <li hidden={!startTime}>Start Time: {timeMapping[startTime || '']}</li>
        {/* finish time */}
        <li hidden={!finishTime}>
          Finish Time: {timeMapping[finishTime || '']}
        </li>
      </ul>

      {offered && (
        <div className="hidden max-w-md gap-3 mt-6 lg:grid">
          <Button color="accent" size="lg" block onClick={onAcceptOffer}>
            Accept New Spot
          </Button>

          <Button
            size="lg"
            clear
            block
            className="mx-auto underline"
            onClick={onOther}
          >
            Other
          </Button>
        </div>
      )}
    </div>
  );
};
export default RescheduleSection;
